//REDUX
import { combineReducers } from "redux"
//REDUX-TOOLKIT
import { configureStore } from "@reduxjs/toolkit"
//SLICES
import drawerSlice from "./drawer/drawerSlice"
import { setDrawerTab } from "./drawer/drawerSlice"
import userSlice from "./user/userSlice"
import walletsSlice from "./wallets/walletsSlice"
import referralSlice from "./referral/referralSlice"
import notificationsSlice from "./notifications/notificationsSlice"
import shopSlice from "./shop/shopSlice"
import utilsSlice from "./utils/utilsSlice"
import legalcontentSlice from "./legalcontent/legalcontentSlice"
import migrationSlice from "./migration/migrationSlice"
import profileSlice from "./profile/profileSlice"
import swapSlice from "./swap/swapSlice"
import settingSlice from "./setting/settingSlice"
import featureSlice from "./feature/featureSlice"
import claimedSlice from "./claimed/claimedSlice"
import supportChatSlice from "./supportChat/supportChatSlice"

const rootReducer = combineReducers({
    drawer: drawerSlice,
    user: userSlice,
    wallet: walletsSlice,
    referral: referralSlice,
    notifications: notificationsSlice,
    shop: shopSlice,
    utils: utilsSlice,
    legalcontent: legalcontentSlice,
    migration: migrationSlice,
    profile: profileSlice,
    swap: swapSlice,
    setting: settingSlice,
    feature: featureSlice,
    claimed: claimedSlice,
    supportChat: supportChatSlice,
})

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export const handleTabChange = (newTab: string) =>
    store.dispatch(setDrawerTab(newTab))
